export const CANCEL_TX = 'Cancel'
export const SEND_TX = 'Send'
export const PENDING = 'pending'
export const ALL = 'all'

export const displayText = {
  all: 'Everyone at this school',
  admin: 'Administrators',
  leaderTeam: 'Leader Team',
  teacher: 'Teachers',
  pending: 'Pending Accounts Only',
}
